import {ReactTooltip} from "../../tooltips/ReactTooltip";
import {Header} from "@tanstack/react-table";
import {Localizer} from "../../../../infrastructure/localization/localizer";
import {EmblaIcons} from "../../../emblaIcons";
import useScreenResolution from "../../../hooks/useScreenResolution";
import '../ReactTableStyles.scss';
import ReactTableContextMenuButton from "./ReactTableContextMenuButton";

type ReactTableContextMenuProps<T> = {
    header: Header<T, unknown>
    enableColumnGrouping?: boolean;
}
const ReactTableContextMenu = <T, >({header, enableColumnGrouping}: ReactTableContextMenuProps<T>) => {
    const {isMobile} = useScreenResolution();
    return (
        <ReactTooltip selectId={header.column.id} clickable openOnClick delay={0}
                      additionalClasses={"tooltip-no-padding"}>
            <div className={"flex-container-column"}>
                {header.column.getCanPin() && !isMobile && (
                    <>
                        {header.column.getIsPinned() !== 'left' ? (
                            <ReactTableContextMenuButton
                                label={Localizer.reactTable_pinLeft()}
                                icon={EmblaIcons.ArrowLeft}
                                onClick={() => header.column.pin('left')}
                            />
                        ) : null}
                        {header.column.getIsPinned() ? (
                            <ReactTableContextMenuButton
                                label={Localizer.reactTable_unpin()}
                                icon={EmblaIcons.Close}
                                onClick={() => header.column.pin(false)}
                            />
                        ) : null}
                        {header.column.getIsPinned() !== 'right' ? (
                            <ReactTableContextMenuButton
                                label={Localizer.reactTable_pinRight()}
                                icon={EmblaIcons.ArrowRight}
                                onClick={() => header.column.pin('right')}
                            />
                        ) : null}
                    </>
                )}
                {header.column.getCanGroup() && enableColumnGrouping &&
                    <ReactTableContextMenuButton
                        label={header.column.getIsGrouped() ? Localizer.reactTable_removeGrouping() : Localizer.reactTable_group()}
                        icon={header.column.getIsGrouped() ? EmblaIcons.List : EmblaIcons.ListAdd}
                        onClick={header.column.getToggleGroupingHandler()}
                    />
                }
            </div>
        </ReactTooltip>
    )
}
export default ReactTableContextMenu;
